import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { collection, query, where, getDocs } from '@firebase/firestore';
import { db } from '../firebase-config';
import NotFound from '../notfound/NotFound';
import { applySeo, siteUrl, stripHtml, truncateText } from '../../utils/seo';
import BlogPostArticle from './BlogPostArticle';
import { getPublishedDateValue, resolveFeaturedImage } from './postUtils';

const Post = () => {
    const { blogURL } = useParams();
    const [blog, setBlog] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getBlog = async () => {
            const blogsRef = collection(db, "posts");
            const q = query(blogsRef, where("url", "==", blogURL), where("is_active", "==", 1));
            const querySnapshot = await getDocs(q);
            if (!querySnapshot.empty) {
                querySnapshot.forEach((document) => {
                    setBlog(document.data());
                });
            }
            setLoading(false);
        };

        getBlog();
    }, [blogURL]);

    useEffect(() => {
        if (!blog?.title) {
            return;
        }

        const summarySource =
            blog.summary_markdown ||
            blog.summary ||
            blog.body_markdown ||
            blog.body_html ||
            blog.body ||
            `${blog.title} on AstroDavido astrophotography`;

        const description = truncateText(stripHtml(summarySource), 155);

        applySeo({
            title: `${blog.title} | David Joyce Astrophotography Blog`,
            description,
            canonicalPath: `/blog/${blog.url || blogURL}/`,
            ogType: 'article',
            ogImage: resolveFeaturedImage(blog) || `${siteUrl}/logo192.png`,
            structuredData: {
                '@context': 'https://schema.org',
                '@type': 'BlogPosting',
                headline: blog.title,
                description,
                image: resolveFeaturedImage(blog) || undefined,
                datePublished: getPublishedDateValue(blog)?.toDate?.()?.toISOString?.() || undefined,
                author: {
                    '@type': 'Person',
                    name: 'David Joyce'
                },
                publisher: {
                    '@type': 'Person',
                    name: 'David Joyce'
                },
                url: `${siteUrl}/blog/${blog.url || blogURL}/`
            }
        });
    }, [blog, blogURL]);

    if (loading) {
        return <div className='admin-status-message'>Loading post...</div>;
    }

    if (!blog?.title) {
        return <NotFound />;
    }

    return (
        <BlogPostArticle blog={blog} />
    );

};

export default Post;
